import React from "react";

import { SelectDownIcon } from "@/Components/Icons/SelectDownIcon";
import SidebarIcons from "@/Components/Icons/SidebarIcons";
/**
 * Function component for rendering a sidebar link dropdown.
 *
 * @param {string} href - The URL of the link
 * @param {string} type - The type of the link
 * @param {string} text - The text to display for the link
 * @param {node} children - The child components
 * @param {string} activePage - The active page
 * @param {function} func - The function to be called on click
 * @param {boolean} isOpened - Flag to indicate if the dropdown is opened
 * @return {JSX} The rendered sidebar link dropdown component
 */
const SidebarLinkDropdown = ({
  href,
  type,
  text,
  children,
  activePage,
  func,
  isOpened,
  cls = "",
  isExanded = false,
}) => {
  return (
    <>
      <div className={`group/item flex flex-col gap-1`}>
        <button
          type="button"
          className={`transition-linear flex h-[42px] items-center rounded-lg px-4 py-2 text-[14px] font-semibold !no-underline !duration-200 ${
            activePage === type
              ? "tour-invited-clientsidebar tour-unfilled-clientsidebar tour-applied-clientsidebar tour-booked-clientsidebar tour-worked-clientsidebar tour-submitted-clientsidebar tour-authorised-clientsidebar tour-terminated-clientsidebar tour-qr-code tour-job-rate-clientsidebar tour-applocum-invoice-clientsidebar tour-applocum-download-clientsidebar bg-primary-100 !text-primary"
              : "text-txtColor hover:bg-grey"
          }`}
          onClick={func}
        >
          <div
            className={`transition-linear relative flex w-full justify-start group-hover:gap-4 ${cls ? "" : null}`}
          >
            <SidebarIcons type={activePage === type ? `${type}Active` : type} />
            <span
              className={`${isExanded ? "w-0" : ""} transition-linear absolute left-[40px] top-[2px] inline-block overflow-hidden whitespace-nowrap text-left group-hover:w-[calc(100%-48px)]`}
            >
              {text}
            </span>
            <SelectDownIcon
              cls={`absolute top-1/2 -translate-y-1/2 right-0 ${isExanded ? "opacity-0" : ""}  group-hover:opacity-100 transition-linear ${isOpened ? "rotate-180" : ""}`}
            />
          </div>
        </button>
        {children}
      </div>
    </>
  );
};

export default SidebarLinkDropdown;
